import type { CasinoGamesRow } from "./casinoGamesColumns";
import { AppStrings } from "../../../utils/constants/AppStrings";

function escapeCsvCell(value: string | number): string {
  let s = String(value);
  if (/^[=+\-@]/.test(s)) {
    s = `'${s}`;
  }
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

const CSV_COLUMNS: { key: keyof CasinoGamesRow; label: string }[] = [
  { key: "name", label: AppStrings.NAME },
  { key: "providerName", label: AppStrings.CASINO_GAMES_COL_PROVIDER },
  { key: "category", label: AppStrings.CASINO_GAMES_COL_CATEGORY },
  { key: "uniquePlayers", label: AppStrings.CASINO_PROVIDERS_COL_UNIQUE_PLAYERS },
  { key: "rounds", label: AppStrings.CASINO_FINANCE_COL_ROUNDS },
  { key: "avgRounds", label: AppStrings.CASINO_PROVIDERS_COL_AVG_ROUNDS },
  { key: "turnover", label: AppStrings.CASINO_FINANCE_COL_TURNOVER },
  { key: "wins", label: AppStrings.CASINO_FINANCE_COL_WINS },
  { key: "rtpPct", label: AppStrings.CASINO_FINANCE_COL_RTP },
  { key: "ggr", label: AppStrings.CASINO_FINANCE_COL_GGR },
  { key: "avgBet", label: AppStrings.CASINO_FINANCE_COL_AVG_BET },
];

export function buildCasinoGamesTableCsv(rows: CasinoGamesRow[]): string {
  const header = CSV_COLUMNS.map((column) => escapeCsvCell(column.label)).join(",");
  const lines = [header];
  for (const r of rows) {
    lines.push(
      CSV_COLUMNS.map((column) =>
        escapeCsvCell(r[column.key] as string | number),
      ).join(","),
    );
  }
  return lines.join("\n");
}
